import React, { useState, useEffect } from "react";
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import LandingPage from "./components/LandingPage";
import AuthModal from "./components/AuthModal";
import Dashboard from "./components/Dashboard";
import CourseView from "./components/CourseView";
import PreRegistrationPage from "./components/PreRegistrationPage";
import PodcastPage from "./components/PodcastPage";

const Router = process.env.REACT_APP_ROUTER_MODE === 'hash' ? HashRouter : BrowserRouter;

const DashboardRoute = ({ user, onLogout, onShowAuth, onAuthMode }) => {
  if (user === null) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}><p>Carregando...</p></div>;
  if (user) return <Dashboard user={user} onLogout={onLogout} />;
  return <LandingPage user={user} onShowAuth={onShowAuth} onAuthMode={onAuthMode} onLogout={onLogout} />;
};

const CourseRoute = ({ user, onLogout, onShowAuth, onAuthMode }) => {
  if (user === null) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}><p>Carregando...</p></div>;
  if (user) return <CourseView user={user} onLogout={onLogout} />;
  return <LandingPage user={user} onShowAuth={onShowAuth} onAuthMode={onAuthMode} onLogout={onLogout} />;
};

export default function App() {
  const [user, setUser] = useState(null);
  const [showAuth, setShowAuth] = useState(false);
  const [authMode, setAuthMode] = useState('login');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setUser(undefined); return; }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` }})
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setUser).catch(() => { localStorage.removeItem('token'); setUser(undefined); });
  }, []);

  const handleAuthSuccess = (u, token) => { setUser(u); localStorage.setItem('token', token); setShowAuth(false); };
  const handleLogout = () => { setUser(undefined); localStorage.removeItem('token'); };

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage user={user} onShowAuth={setShowAuth} onAuthMode={setAuthMode} onLogout={handleLogout} />} />
          <Route path="/dashboard" element={<DashboardRoute user={user} onLogout={handleLogout} onShowAuth={setShowAuth} onAuthMode={setAuthMode} />} />
          <Route path="/course" element={<CourseRoute user={user} onLogout={handleLogout} onShowAuth={setShowAuth} onAuthMode={setAuthMode} />} />
          <Route path="/pre-registration" element={<PreRegistrationPage />} />
          <Route path="/podcast" element={<PodcastPage />} />
        </Routes>
      </Router>
      {showAuth && <AuthModal mode={authMode} onClose={() => setShowAuth(false)} onSuccess={handleAuthSuccess} onSwitchMode={(m)=>setAuthMode(m)} />}
    </div>
  );
}
